export const GlobalEventNames = {
    UnityLessonPreviewClose: 'closeLessonPreview',
    UnityLessonPreviewReload: 'unityLessonPreviewReload',
    UnityLessonPreviewDialogClose: 'unityLessonPreviewDialogClose',
    UnityLessonPreviewOnLoad: 'unityLessonPreviewOnLoad',
    UnityLessonPreviewHideShowToggle: 'unityLessonPreviewHideShowToggle',
    UnityLessonPreviewOnHide: 'unityLessonPreviewOnHide',
    UnityLessonPreviewOnShow: 'unityLessonPreviewOnShow',
    CapeeshWebSetFullScreenToggle: 'capeeshWebSetFullScreenToggle',
}

export const GlobalEvents = {
    UnityLessonPreviewClose: new Event(GlobalEventNames.UnityLessonPreviewClose),
    UnityLessonPreviewReload: new Event(GlobalEventNames.UnityLessonPreviewReload),
    UnityLessonPreviewDialogClose: new Event(GlobalEventNames.UnityLessonPreviewDialogClose),
    UnityLessonPreviewOnLoad: new Event(GlobalEventNames.UnityLessonPreviewOnLoad),
    UnityLessonPreviewHideShowToggle: new Event(GlobalEventNames.UnityLessonPreviewHideShowToggle),
    UnityLessonPreviewOnHide: new Event(GlobalEventNames.UnityLessonPreviewOnHide),
    UnityLessonPreviewOnShow: new Event(GlobalEventNames.UnityLessonPreviewOnShow),
    CapeeshWebSetFullScreenToggle: new Event(GlobalEventNames.CapeeshWebSetFullScreenToggle),
}
